import { Slider } from '@mui/material'
import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'
import '../ConsumableShop.css'

interface ConsumableItemProps {
    type: 'fuel' | 'oil' | 'nitro' | 'tyre';
    text: string;
    amount: number;
    setAmount: (amount: number) => void;
    availableAmount: number;
    pricePerItem: number;
    onBuyClicked: () => void;
    max: number;
    min: number;
    step: number;
    measureText: string;
}

export const ConsumableItem = ({ 
    type, 
    text, 
    amount, 
    setAmount, 
    pricePerItem, 
    onBuyClicked, 
    max, 
    min, 
    step,
    measureText,
    availableAmount
}: ConsumableItemProps) => {
    
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];


    return (
        <div className="consumable-item">
            <div className="consumable-item-content">
                <img 
                    className="consumable-item-icon"
                    src={`/icons/256px/${type}.png`} 
                    alt={type}
                />
                <p className="consumable-item-title">{text}</p>
                <div className="consumable-item-slider">
                    <Slider
                        min={min}
                        max={max}
                        step={step}
                        color="error"
                        sx={{ color: '#FFA616' }}
                        value={amount}
                        onChange={(event, newValue) => setAmount(newValue)}
                    />
                    <div className="consumable-item-slider-value">
                        {amount.toFixed(0)} {measureText}
                    </div>
                </div>
                <div className='consumable-item-footer'>
                    <p>{t.you_have}: {availableAmount.toFixed(0)} {measureText}</p>
                    <div className="donate-to-money-convert-button-container consumable-item-button">
                        <div 
                            onClick={() => onBuyClicked()} 
                            className="donate-to-money-convert-button consumable-item-button-text"
                        >
                            <p>{t.buy_up} {Math.ceil(pricePerItem * amount)}$</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};